import {ITokenModel} from './itoken.model';
import {Observable} from 'rxjs';
import {inject, InjectionToken} from "@angular/core";
import {TokenService} from "./token.service";
import {DA_STORE_TOKEN} from "./istore.interface";

export const DA_SERVICE_TOKEN = new InjectionToken<ITokenService>('DA_SERVICE_TOKEN', {
  providedIn: 'root',
  factory: DA_SERVICE_TOKEN_FACTORY,
});

export function DA_SERVICE_TOKEN_FACTORY(): ITokenService {
  return new TokenService(inject(DA_STORE_TOKEN));
}

export interface ITokenService {
  set(data: ITokenModel): boolean;
  get(type?: any): ITokenModel;
  get<T extends ITokenModel>(type?: any): T;
  clear(): void;
  change(): Observable<ITokenModel>;
}

